"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCookiesEnabled = void 0;
const Log = __importStar(require("./Log"));
const checkCookiesEnabled = () => {
    try {
        // Quick test if browser has cookieEnabled host property
        if (navigator.cookieEnabled)
            return true;
        // Create cookie
        document.cookie = "cookietest=1";
        const ret = document.cookie.indexOf("cookietest=") !== -1;
        // Delete cookie
        document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        return ret;
    }
    catch (e) {
        const message = e instanceof Error
            ? e.message
            : "Error checking if cookies are enabled";
        Log.error(message, { originalException: e });
        return true; //Not sure how this could throw, but worth letting user through just in case
    }
};
exports.checkCookiesEnabled = checkCookiesEnabled;
//# sourceMappingURL=cookies.js.map